import MarketplaceBanners from './MarketplaceBanners'

export default MarketplaceBanners
